<span>{{getSeasonNum()}}{{getEpisodeNum()}}</span>